import { CustomPageHeader, Text } from '@src/components';
import ActiveCardList from './ActiveCardList';
import CanceledCardList from './CanceledCardList';
import BlockedCardList from './BlockedCardList';
import { useEffect } from 'react';
import { cardGetPagedList } from '@src/store/slice/manageMyCardsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addressGetPagedListByUserQuery } from '@src/store/slice/addressSlice';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const ActiveList = ({ filterObject }) => {
  switch (filterObject?.body?.statusId) {
    case null:
      return <ActiveCardList />;
    case 60:
      return <CanceledCardList />;
    case 50:
      return <BlockedCardList />;
    default:
      return <ActiveCardList />;
  }
};

const ManageMyCards = ({ isCompliments = false, isMarket = false }) => {
  const dispatch = useDispatch();
  const { filterObject } = useSelector((state) => state?.manageMyCards);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  let vouId;
  let header;

  if (isMarket) {
    vouId = VouIdCode.Market;
    header = 'ticketMarketHeader';
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
    header = 'ticketCompliments';
  } else {
    vouId = VouIdCode.Restaurant;
    header = 'ticketRestaurantHeader';
  }

  useEffect(() => {
    (async () => {
      await dispatch(
        cardGetPagedList({
          body: { vouId: vouId },
          pageNumber: 1,
          pageSize: (isCompliments || isMarket) ? 100 : undefined,
        }),
      );
      await dispatch(
        addressGetPagedListByUserQuery({
          body: { vouId: vouId },
          pageNumber: 0,
          pageSize: 0,
          customerId: selectedCustomer?.customerId,
        }),
      );
    })();

    window.scrollTo(0, 0);
  }, [dispatch, selectedCustomer]);

  return (
    <CustomPageHeader
      data-testid="manage-my-cards"
      title={<Text t="myCards" />}
      showBreadCrumb
      showHelpButton
      routes={[header]}
    >
      {(isCompliments || isMarket) ? (
        <ActiveCardList isCompliments={isCompliments} isMarket={isMarket} />
      ) : (
        <ActiveList filterObject={filterObject} />
      )}
    </CustomPageHeader>
  );
};

ManageMyCards.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};

export default ManageMyCards;
